import React from 'react';

import Button from '@atoms/Button/Button';
import Divider from '@atoms/Divider/Divider';
import Text from '@atoms/Text/Text';
import Title from '@atoms/Title/Title';
import MailchimpForm from '../MailchimpForm/MailchimpForm';
import TextList from '../TextList/TextList';

import './_SignupForm.scss';

function SignupForm(props) {
    let mod_class = ['SignupForm', props.hasBorder ? 'has-border' : ''];
    mod_class = mod_class.join(' ');

    function goToProviderForm() {
        // Only for AdWords
        typeof window !== 'undefined' &&
            window.gtag('event', 'lead_therapist', {
                send_to: 'AW-482685496/MLw8CMKUhOwCELjklOYB',
            });
        typeof window !== 'undefined' &&
            window.open('https://forms.gle/MsUo3FYSb18VHVQe7', '_blank');
    }

    return (
        <div className={mod_class}>
            <Title size="l">{props.title}</Title>
            {/* <Divider spacing='xs' invisible /> */}
            {props.list ? (
                <div className="g_clearfix">
                    <div className="g_1_2">
                        <Text align="left">{props.description}</Text>
                    </div>
                    <div className="g_1_2 g_hide_mobile">
                        <TextList data={props.list} />
                    </div>
                </div>
            ) : (
                <div className="g_clearfix">
                    <div className="g_1_1">
                        <Text align="left">{props.description}</Text>
                    </div>
                </div>
            )}
            <Divider spacing="xxs" invisible />
            {props.from !== 'therapist' ? (
                <MailchimpForm MCFrom={props.from} cta={props.cta} />
            ) : (
                <Button
                    size="l"
                    label="Jetzt unverbindlich anfragen"
                    onClick={goToProviderForm}
                />
            )}
        </div>
    );
}

export default SignupForm;
